import api from '@api/instance';
import { ScheduledMaintenance } from './schedule-maintenance.model';
import { Page } from '@models/page';
import { Observable } from 'rxjs';
 

const nameSpace = '/scheduled_maintenances';

const getMaintenances = (size, page) => {
  return api
    .get(`${nameSpace}`, { size, page })
    .then((res) =>
      new Page<ScheduledMaintenance>().deserialize(res, ScheduledMaintenance),
    )
    .catch((e) => Promise.reject(e));
};

const ScheduledMaintenanceService = {
  getMaintenances,
};

export default ScheduledMaintenanceService;
